import React from 'react';

const ContactHeader = () => {
  return (
    <section className="page-header bg--cover" style={{backgroundImage: "url(assets/images/header/1.png)"}}>
      <div className="container">
        <div className="page-header__content" data-aos="fade-right" data-aos-duration="1000">
          <h2 className="text-uppercase">Contact Us</h2>
          <nav style={{"--bs-breadcrumb-divider": "'/'"} } aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item text-uppercase"><a href="/">Home</a></li>
              <li className="breadcrumb-item text-uppercase active" aria-current="page">Contact Us</li>
            </ol>
          </nav>
        </div>
        <div className="page-header__shape">
          <span className="page-header__shape-item page-header__shape-item--1">
            <img src="assets/images/header/2.png" alt="shape-icon" />
          </span>
        </div>
      </div>
    </section>
  );
};

export default ContactHeader;